// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"663":"css/admin-app.6893","4343":"css/app.6893"}[chunkId] + ".css";
};